import React from 'react'

import {
  getIsForInAppPresentation,
  IndexLayoutExtraProps,
  RouteProps,
  useQueryParams,
} from '@sketch/modules-common'

import { RedirectingToIdentityProvider, SsoSignInView } from 'cloud-frontend'

export interface SsoSignInRouteProps
  extends RouteProps<'SSO_SIGN_IN'>,
    IndexLayoutExtraProps {}

export const SsoSignInRoute = (props: SsoSignInRouteProps) => {
  const { useOverrideLayoutProps } = props
  const { team, shortname } = useQueryParams<'SSO_SIGN_IN'>()
  const isForInAppPresentation = getIsForInAppPresentation()

  useOverrideLayoutProps({ variant: 'orange' })

  if (isForInAppPresentation && (team || shortname)) {
    return <RedirectingToIdentityProvider />
  }

  return <SsoSignInView {...props} />
}
